    // // 新建DOM，将需要打印的内容填充到DOM
    // function getPrintContainer(html) {
    //   // 清除打印
    //   cleanPrint()
    //   let container = document.createElement('div')
    //   container.setAttribute('id', 'print-container')
    //   container.innerHTML = html
    //   return container
    // }
    // // 设置打印样式
    // function getStyle() {
    //   // 新建的dom不需要在页面上展示
    //   let styleContent = `#print-container {
    //       display: none;
    //   }
    //   @media print {
    //       body > :not(.print-container) {
    //       display: none;
    //   }
    //   html,
    //   body {
    //       display: block !important;
    //   }
    //   #print-container {
    //       display: block;
    //       width: 1000px;
    //       margin: 0 auto;
    //       text-align: center !important;
    //   }
    //   .el-row {
    //     border: 1px solid #e8e8e8 !important;
    //   }
  
    //   .el-col {
    //     // display: inline-block;
    //     // border-bottom: 1px solid #e8e8e8 !important;
    //     // border-right: 1px solid #e8e8e8 !important;
    //     // text-align: center !important;
    //   }
    //   .el-select{
    //     display: none;
    //   }
    //   .w-22{
    //     width: 22%;
    //   }
    //   .w-26{
    //     width: 26%;
    //   }
  
    //   .bg-purple {
    //     background: #fff;
    //     font-weight: bold;
    //   }
    //   .c-00b1c3{
    //     color: #00b1c3;
    //   }
    //   .c-ed8599{
    //     color: #ed8599;
    //   }
    //   .c-b4d049{
    //     color: #b4d049;
    //   }
  
    //   .grid-title {
    //     // min-height: 36px;
    //     padding: 10px 0;
    //     line-height: 2.2;
    //     font-size: 24px;
    //   }
  
    //   .grid-content {
    //     min-height: 36px;
    //     line-height: 2.2;
    //   }
  
    //   .row-bg {
    //     padding: 10px 0;
    //     background-color: #fff;
    //   }
  
    //   .staffImg {
    //     display: block;
    //     width: 100px;
    //     height: 100px;
    //     margin: 10px auto 10px;
    //     border-radius: 50%;
    //   }
  
    //   .leftLabel {
    //     color: #386ed3;
    //     text-align: right;
    //     padding-right: 20px;
    //     font-size: 15px;
    //   }
  
    //   .rowTop {
    //     height: 150px;
  
    //     .el-col {
    //       height: 100%;
    //       background-color: #fff;
    //       position: relative;
    //     }
  
    //     .closeIcon {
    //       font-size: 40px;
    //       color: #999;
    //       position: absolute;
    //       right: 10px;
    //       display: none;
    //     }
  
    //     .leftTop {
    //       color: #386ed3;
    //       // line-height: 200px;
    //       margin-top: 50px;
    //       text-align: right;
    //       padding-right: 20px;
    //     }
  
    //     .w280 {
    //       width: 70%;
    //     }
    //   }`
    //   let style = document.createElement('style')
    //   style.innerHTML = styleContent
    //   return style
    // }
    // // 清空打印的DOM
    // function cleanPrint() {
    //   let divDOM = document.getElementById('print-container')
    //   // 判断是否存在，有则删除
    //   if (divDOM) {
    //     document.querySelector('body').removeChild(divDOM)
    //   }
    // }

    // // 等待图片完全加载后再调用打印方法
    // function getLoadPromise(dom) {
    //   let imgs = dom.querySelectorAll('img')
    //   imgs = [].slice.call(imgs)
    //   if (imgs.length === 0) {
    //     return Promise.resolve()
    //   }
    //   let finishedCount = 0
    //   return new Promise(resolve => {
    //     function check() {
    //       finishedCount++
    //       if (finishedCount === imgs.length) {
    //         resolve()
    //       }
    //     }
    //     imgs.forEach(img => {
    //       img.addEventListener('load', check)
    //       img.addEventListener('error', check)
    //     })
    //   })
    // }
    // // 默认暴露打印方法
    // export default function printHtml(html) {
    //   let style = getStyle()
    //   let container = getPrintContainer(html)
    //   document.body.appendChild(style)
    //   document.body.appendChild(container)
    //   getLoadPromise(container).then(() => {
    //     // 打印
    //     window.print()
    //     document.body.removeChild(style)
    //     // 如果body中有则删除（这里最好判断一下，避免使用时报错）
    //     if (document.body.contains(container)) {
    //       document.body.removeChild(container)
    //     }
    //   })
    // }
        // 新建DOM，将需要打印的内容填充到DOM
        function getPrintContainer(html) {
          // 清除打印
          cleanPrint()
          let container = document.createElement('div')
          container.setAttribute('id', 'print-container')
          container.innerHTML = html
          return container
        }
        // 设置打印样式
        function getStyle() {
          // 新建的dom不需要在页面上展示
          let styleContent = `#print-container {
              display: none;
          }
          @media print {
              body > :not(.print-container) {
              display: none;
          }
          html,
          body {
              display: block !important;
          }
          #print-container {
              display: block;
              width: 1000px;
              margin: 0 auto;
              text-align: center !important;
          }
          .el-row {
            // border: 1px solid #e8e8e8 !important;
            // border-bottom: 1px solid #e8e8e8 !important;
            // border-right: 1px solid #e8e8e8 !important;
          }
      
          .el-col {
            // display: inline-block;
            // border-bottom: 1px solid #e8e8e8 !important;
            // border-right: 1px solid #e8e8e8 !important;
            // text-align: center !important;
          }
          .el-select{
            display: none;
          }
          .w-22{
            width: 22%;
          }
          .w-26{
            width: 26%;
          }
          .rowTop .bg-purple{
            border: none !important;
          }
          .rowTop .el-col{
            border: 1px solid #e8e8e8 !important;
            // border-bottom: 1px solid #e8e8e8 !important;
            // border-right: 1px solid #e8e8e8 !important;
          }
          .row-equal-height{
            display: flex;
          }
          .row-equal-height .el-col{
            min-height: 36px;
          }

          .col-content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: stretch;
            padding: 10px;
            height: 100%;
          }
    
          .bg-purple {
            background: #fff;
            font-weight: bold;
            border: 1px solid #e8e8e8 !important;
          }
          .c-00b1c3{
            color: #00b1c3;
          }
          .c-ed8599{
            color: #ed8599;
          }
          .c-b4d049{
            color: #b4d049;
          }
      
          .grid-title {
            // min-height: 36px;
            padding: 10px 0;
            line-height: 2.2;
            font-size: 24px;
          }
      
          .grid-content {
            min-height: 36px;
            line-height: 2.2;
          }
      
          .row-bg {
            padding: 10px 0;
            background-color: #fff;
          }
      
          .staffImg {
            display: block;
            width: 100px;
            height: 100px;
            margin: 10px auto 10px;
            border-radius: 50%;
          }
      
          .leftLabel {
            color: #386ed3;
            text-align: right;
            padding-right: 20px;
            font-size: 15px;
          }
      
          .rowTop {
            height: 150px;
      
            .el-col {
              height: 100%;
              background-color: #fff;
              position: relative;
            }
      
            .closeIcon {
              font-size: 40px;
              color: #999;
              position: absolute;
              right: 10px;
              display: none;
            }
      
            .leftTop {
              color: #386ed3;
              // line-height: 200px;
              margin-top: 50px;
              text-align: right;
              padding-right: 20px;
            }
      
            .w280 {
              width: 70%;
            }
          }`
          let style = document.createElement('style')
          style.innerHTML = styleContent
          return style
        }
        // 清空打印的DOM
        function cleanPrint() {
          let divDOM = document.getElementById('print-container')
          // 判断是否存在，有则删除
          if (divDOM) {
            document.querySelector('body').removeChild(divDOM)
          }
        }
    
        // 等待图片完全加载后再调用打印方法
        function getLoadPromise(dom) {
          let imgs = dom.querySelectorAll('img')
          imgs = [].slice.call(imgs)
          if (imgs.length === 0) {
            return Promise.resolve()
          }
          let finishedCount = 0
          return new Promise(resolve => {
            function check() {
              finishedCount++
              if (finishedCount === imgs.length) {
                resolve()
              }
            }
            imgs.forEach(img => {
              img.addEventListener('load', check)
              img.addEventListener('error', check)
            })
          })
        }
        // 默认暴露打印方法
        export default function printHtml(html) {
          let style = getStyle()
          let container = getPrintContainer(html)
          document.body.appendChild(style)
          document.body.appendChild(container)
          getLoadPromise(container).then(() => {
            // 打印
            window.print()
            document.body.removeChild(style)
            // 如果body中有则删除（这里最好判断一下，避免使用时报错）
            if (document.body.contains(container)) {
              document.body.removeChild(container)
            }
          })
        }